import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { useModalOpen } from '@src/hooks/useModalOpen';
import styles from './index.css';

const Wrap = ({ children, top, onClose }) => {
    useModalOpen();

    return (
        <div
            className={styles.mask}
            onClick={e => {
                e.stopPropagation();
                onClose();
            }}
            onTouchMove={e => e.stopPropagation()}>
            <div
                className={styles.content}
                style={{ top }}
                onClick={e => {
                    e.stopPropagation();
                }}>
                {children}
            </div>
        </div>
    );
};

Wrap.propTypes = {
    children: PropTypes.any,
    top: PropTypes.number,
    onClose: PropTypes.func,
};

const Sheet = ({ show, children, top, onClose }) => {
    return show
        ? ReactDOM.createPortal(
              <Wrap top={top} onClose={onClose}>
                  {children}
              </Wrap>,
              document.body,
          )
        : null;
};

export default Sheet;
